const route = {
    path: "/other-services",
    meta: {
        layout: 'PageLayout'
    },
    children: [
        {
            path: "commercial-certification",
            name: "CommercialCertification",
            component: () => import( /*webpackChunkName: "other-services"*/ "./view/CommercialCertification.vue"),
            meta: {
                title: "商事认证业务",
                isRequiredAuth: true,
                isRequiredEnterpriseAuth: false
            }
        },
        {
            path: "common-excel",
            name: "CommonExcel",
            component: () => import( /*webpackChunkName: "other-services"*/ "./view/CommonExcel.vue"),
            meta: {
                title: "常用表格",
                isRequiredAuth: true,
                isRequiredEnterpriseAuth: false
            }
        },
        {
            path: "certification-requirements",
            name: "CertificationRequirements",
            component: () => import( /*webpackChunkName: "other-services"*/ "./view/CertificationRequirements.vue"),
            meta: {
                title: "各国驻广州领馆认证要求汇编",
                isRequiredAuth: true,
                isRequiredEnterpriseAuth: false
            }
        },
    ]
}

export default route